module.exports = __webpack_public_path__ + "static/banner-image-1-1-4bb00f607b491da52b7e079bf51c5fc6.jpg";